import React, { useEffect } from 'react';
import { useQuizz } from "../../../application/quizz/hooks/useQuizz";
import ToolbarComponent from '../../ui/section';
import DynamicTable from '../../ui/table2';
import Loader from '../../ui/loader';
import { ModalConfirm } from '../../ui/modal2';
import FloatingButton from '../../ui/floatButton';

const QuizzesPage = (props) => {
    const { 
        columns, 
        quizzes, 
        customElements, 
        isLoading, 
        removeModal, 
        setRemoveModal, 
        handleRemoveConfirm, 
        newQuizz,
        getAll,
    } = useQuizz(props);

    useEffect(() => {
        getAll();
    }, [getAll]);
    return (
        <>
            <ToolbarComponent label="Quizzes" showBackButton={false}>
                <DynamicTable
                    headers={columns}
                    data={quizzes}
                    customElements={customElements}
                    fullPage={true}
                    showLabel={false}
                    loaderComponent={<Loader text="Cargando datos" />}
                    isLoading={isLoading}
                />
            </ToolbarComponent>
            <ModalConfirm isOpen={removeModal} onClose={() => setRemoveModal(false)} onAccept={handleRemoveConfirm} />
            <FloatingButton text="Nuevo quizz" onClick={newQuizz} />
        </>
    )
}

export default QuizzesPage;